var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowCircleDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14.4C9.69748 14.4 11.3253 13.7257 12.5256 12.5255C13.7258 11.3253 14.4001 9.69739 14.4001 8.00001C14.4001 6.30262 13.7258 4.67476 12.5256 3.47452C11.3253 2.27429 9.69748 1.60001 8.0001 1.60001C6.30271 1.60001 4.67485 2.27429 3.47461 3.47452C2.27438 4.67476 1.6001 6.30262 1.6001 8.00001C1.6001 9.69739 2.27438 11.3253 3.47461 12.5255C4.67485 13.7257 6.30271 14.4 8.0001 14.4ZM8.8001 5.60001C8.8001 5.38783 8.71581 5.18435 8.56578 5.03432C8.41575 4.88429 8.21227 4.80001 8.0001 4.80001C7.78792 4.80001 7.58444 4.88429 7.43441 5.03432C7.28438 5.18435 7.2001 5.38783 7.2001 5.60001V8.46881L6.1657 7.43441C6.01482 7.28868 5.81273 7.20804 5.60298 7.20987C5.39322 7.21169 5.19257 7.29583 5.04424 7.44415C4.89592 7.59248 4.81178 7.79313 4.80996 8.00289C4.80814 8.21264 4.88877 8.41472 5.0345 8.56561L7.4345 10.9656C7.58452 11.1156 7.78797 11.1998 8.0001 11.1998C8.21223 11.1998 8.41568 11.1156 8.5657 10.9656L10.9657 8.56561C11.1114 8.41472 11.1921 8.21264 11.1902 8.00289C11.1884 7.79313 11.1043 7.59248 10.956 7.44415C10.8076 7.29583 10.607 7.21169 10.3972 7.20987C10.1875 7.20804 9.98538 7.28868 9.8345 7.43441L8.8001 8.46881V5.60001Z",
    fill: "#09090B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleDown);
export default __webpack_public_path__ + "static/media/ArrowCircleDown.76667a9eb07ebc027b0f0b49548b9801.svg";
export { ForwardRef as ReactComponent };